import React, { createRef, useState } from 'react';
import classnames from 'classnames';
import { sorts } from '../../utils';
import Rules from '../../utils/validation_rules';
import { default as ReactSelect } from 'react-select';

const MultiSelect = ({
    label = '',
    showRequired = true,
    hideOptional = false,
    prependLabel = '',
    prepend = false,
    append = false,
    small = false,
    hideLabel = false,
    flex = false,
    labelClass = '',
    labelSubtext = '',
    id = 'MultiSelect',
    validators = [],
    collapse = false,
    value = undefined,
    hidden = false,
    required = false,
    className = '',
    options = [],
    onChange = () => {},
    onBlur = () => {}
}) => {
    let _input = createRef();

    const [isValid, setIsValid] = useState(true);

    const validate = () => {
        let valid = true;
        let rules = validators;
        if (required) {
            rules = ['hasSelected', ...validators];
        }

        if (!value.length && !required) {
            setIsValid(valid);

            return isValid;
        }

        rules.every((rule) => {
            let { func } = Rules[rule];
            let test = func(_input.current);
            valid = valid && test;
            return isValid;
        });

        setIsValid(valid);
        return isValid;
    };

    const handleChange = (selected) => {
        if (!isValid) {
            validate();
        }
        onChange(id, selected);
    };

    const handleBlur = () => {
        validate();
        onBlur();
    };

    let isRequired = required || showRequired;
    let showOptional = !isRequired && !hideOptional;

    if (hidden) {
        return null;
    }

    return (
        <div className={classnames('form-group', { 'mb-0': collapse }, className)}>
            <div className="label-wrapper">
                {label && !prependLabel && (
                    <label
                        htmlFor={id}
                        className={classnames(labelClass, {
                            required: isRequired,
                            'sr-only': hideLabel,
                            flex: flex,
                            'label-sm': small
                        })}
                    >
                        {label}{' '}
                        {showOptional && <span className="text-muted font-weight-normal font-italic">(optional)</span>}
                    </label>
                )}
                {labelSubtext && <span className="form-text-small text-muted">{labelSubtext}</span>}
            </div>
            <div
                className={classnames({
                    'input-group': prepend || prependLabel || append
                })}
            >
                {prepend && (
                    <div className="input-group-prepend">
                        {React.isValidElement(prepend) ? prepend : <span className="input-group-text">{prepend}</span>}
                    </div>
                )}
                {prependLabel && (
                    <div
                        className={classnames('input-group-prepend prepend-label', {
                            'input-group-sm': small
                        })}
                    >
                        <label htmlFor={id} className="input-group-text">
                            {label}
                        </label>
                    </div>
                )}

                <ReactSelect
                    ref={_input}
                    id={id}
                    classNamePrefix="react-select"
                    className={classnames({
                        error: !isValid,
                        'mb-0': collapse,
                        success: isValid,
                        'input-group-control': prepend || prependLabel || append,
                        'input-group-control-prepend': prepend || prependLabel,
                        'input-group-control-append': append,
                        'form-control-sm': small
                    })}
                    value={value.sort((a, b) => sorts.asc(a.label, b.label))}
                    options={options.sort((a, b) => sorts.asc(a.label, b.label))}
                    isMulti
                    isSearchable
                    onBlur={handleBlur}
                    onChange={handleChange}
                />
            </div>
        </div>
    );
};

export default MultiSelect;
